/**
 * Estado de una consignación, en un solo sitio.
 *
 * Estaba calculado a mano en tres pantallas (listado de conduces, estado de
 * cuenta del consignante y detalle de la factura CxP) y las tres discrepaban:
 * dos daban por saldada una consignación que solo estaba al día, porque no
 * miraban si quedaban motores en piso.
 *
 * La distinción importa: que no se deba nada HOY no significa que la
 * consignación esté cerrada. Mientras queden motores en piso, cada venta
 * vuelve a generar deuda. Decir "Saldada" ahí sugiere que la relación con el
 * consignante terminó, y no es cierto.
 *
 * Saldada = todos los motores salieron del piso (vendidos o devueltos) Y se
 * pagó todo lo vendido.
 */

const num = (v) => {
  const n = typeof v === "number" ? v : parseFloat(String(v ?? "").replace(/,/g, ""));
  return Number.isNaN(n) ? 0 : n;
};

// Un centavo de tolerancia, igual que el TOL del backend: los importes son
// dobles y comparar contra 0 exacto dejaba facturas abiertas por redondeo.
const TOL = 0.01;

/**
 * @param {object} row  con anulada, porpagar (o liquidable), sobrepago y enpiso
 * @param {object} opciones  femenino: para "Anulada/Saldada" en vez de "Anulado/Saldado"
 * @returns {{clave: string, label: string, variant: string}}
 */
export function estadoConsignacion(row = {}, { femenino = false } = {}) {
  const fin = femenino ? "a" : "o";
  if (row.anulada) {
    return { clave: "anulada", label: `Anulad${fin}`, variant: "danger" };
  }
  if (num(row.porpagar ?? row.liquidable) > TOL) {
    return { clave: "porpagar", label: "Por pagar", variant: "neutral" };
  }
  if (num(row.sobrepago) > TOL) {
    return { clave: "anticipo", label: "Anticipo", variant: "info" };
  }
  if (Number(row.enpiso || 0) > 0) {
    // Nada que pagar ahora, pero la consignación no está cerrada: lo que
    // queda en piso puede venderse y volver a generar deuda.
    return { clave: "enpiso", label: "En piso", variant: "info" };
  }
  return { clave: "saldada", label: `Saldad${fin}`, variant: "success" };
}

export default estadoConsignacion;
